import { hasPermission } from '../../lib/authz';
import { IUser } from '../../lib/interfaces';

export const isOwnProfile = (
  sessionUser?: IUser | null,
  patient?: IUser | null
) => !!patient?._id && patient._id === sessionUser?._id;

export const canEditContactDetails = (
  sessionUser?: IUser | null,
  patient?: IUser | null
) =>
  isOwnProfile(sessionUser, patient) ||
  (!!patient?.isPatient &&
    !patient.isAdmin &&
    hasPermission(sessionUser, 'patient:delete'));
